import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemsTableRow from "./ItemsTableRow"

class ItemsTableBody extends Component {
    render() {
        const {listJobs} = this.props

        return (
            <tbody>
            {
                listJobs.length > 0 ? listJobs.map((item, index) => {
                        return <ItemsTableRow key={item._id} index={index} item={item}/>
                    })
                    : <tr>
                        <td colSpan={3}>Không có dữ liệu</td>
                    </tr>
            }
            </tbody>
        )
    }
}

ItemsTableBody.propTypes = {
    listJobs: PropTypes.array.isRequired
}

export default ItemsTableBody